'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdBrush = function MdBrush(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.5 7.7c0.7 0.7 0.7 1.8 0 2.4l-14.9 14.9-4.6-4.6 14.9-14.9c0.6-0.7 1.7-0.7 2.4 0z m-22.9 15.7c2.8 0 5 2.2 5 5 0 3.6-2.9 6.6-6.6 6.6-2.5 0-5.1-1.3-6.6-3.4 1.4 0 3.2-1.1 3.2-3.2 0-2.8 2.3-5 5-5z' })
        )
    );
};

exports.default = MdBrush;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/brush.js
// module id = 540
// module chunks = 0